"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactIntl = require("react-intl");

var _bind = _interopRequireDefault(require("classnames/bind"));

var _reactOnclickoutside = _interopRequireDefault(require("react-onclickoutside"));

var _reactTransitionGroup = require("react-transition-group");

var _utils = require("../utils");

var _entries2 = _interopRequireDefault(require("./entries"));

var _messages = _interopRequireDefault(require("./messages"));

var _constants = require("./constants");

var _countSelect = _interopRequireDefault(require("./count-select"));

var _plainSelect = _interopRequireDefault(require("./plain-select"));

var _tagsSelect = _interopRequireDefault(require("./tags-select"));

var _search = _interopRequireDefault(require("./search"));

var _style = _interopRequireDefault(require("./style.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind["default"].bind(_style["default"]);

var TreeSelect = /*#__PURE__*/function (_PureComponent) {
  _inherits(TreeSelect, _PureComponent);

  var _super = _createSuper(TreeSelect);

  function TreeSelect(props) {
    var _this;

    _classCallCheck(this, TreeSelect);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "dropdownRef", null);

    _defineProperty(_assertThisInitialized(_this), "setDropdownRef", function (ref) {
      _this.dropdownRef = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "toggleVisible", function () {
      return _this.setState(function (prevState) {
        return {
          visible: !prevState.visible,
          isSearchActive: prevState.isSearchActive && !prevState.visible
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "convertOptionsToEntries", function (options) {
      var recursiveEach = function recursiveEach(options) {
        return options.map(function (option) {
          return {
            id: option.id,
            label: option.label,
            options: recursiveEach(option.options || []),
            checked: false
          };
        });
      };

      return recursiveEach(options);
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", function () {
      var visible = _this.state.visible;

      if (visible) {
        _this.setState({
          visible: false,
          isSearchActive: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (option) {
      var _option$options;

      var ignoreFound = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
          input = _this$props.input,
          allowMultiSelect = _this$props.allowMultiSelect,
          allowSelectNestedFolder = _this$props.allowSelectNestedFolder;

      if (!allowSelectNestedFolder && ((_option$options = option.options) === null || _option$options === void 0 ? void 0 : _option$options.length)) {
        return;
      }

      if (!allowMultiSelect) {
        _this.toggleVisible();
      }

      var needToDeleteValue = option.checked;
      var value = Array.isArray(input.value) ? input.value : [];

      if (needToDeleteValue && !ignoreFound) {
        input.value = value.filter(function (value) {
          return value.id !== option.id;
        });
      } else {
        input.value = allowMultiSelect ? [].concat(_toConsumableArray(value), [option]) : [option];
      }

      input.onChange(input.value);
      _this.entries = _this.checkedSelectedItems(_this.entries);
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelectAll", function () {
      var recursiveEach = function recursiveEach(entries) {
        return entries.forEach(function (entry) {
          entry.options && recursiveEach(entry.options);
          !entry.disabled && _this.handleChange(entry, true);
        });
      };

      recursiveEach(_this.entries);
    });

    _defineProperty(_assertThisInitialized(_this), "handleUnselectAll", function () {
      var input = _this.props.input;
      input.onChange([]);
      _this.entries = _this.setCheckedStatus(_this.entries, function () {
        return false;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setCheckedStatus", function (entries, statusFn) {
      return entries.map(function (entry) {
        return _objectSpread(_objectSpread({}, entry), {}, {
          options: entry.options && _this.setCheckedStatus(entry.options, statusFn),
          checked: statusFn(entry)
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "checkedSelectedItems", function (entries) {
      var input = _this.props.input;
      return _this.setCheckedStatus(entries, function (entry) {
        if (!Array.isArray(input.value)) {
          return false;
        }

        return !!input.value.find(function (a) {
          return a.id === entry.id;
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "determineDropdownPosition", function () {
      _this.setState({
        position: !(0, _utils.visibleInPage)(_this.dropdownRef) ? 'top' : 'bottom'
      });
    });

    _defineProperty(_assertThisInitialized(_this), "filterEntries", function (value) {
      var entries = _this.state.entries;
      var isSearchActive = Boolean(value.length);
      var lowerValue = value.toLowerCase().trim();

      _this.setState({
        isSearchActive: isSearchActive
      }, function () {
        if (!isSearchActive) {
          return;
        }

        var recursiveEach = function recursiveEach(entries) {
          return entries.filter(function (entry) {
            var label = entry.label.toLowerCase().trim();
            return label.includes(lowerValue) || recursiveEach(entry.options || []).length;
          });
        };

        _this.entries = recursiveEach(entries);
      });
    });

    var _entries = _this.convertOptionsToEntries(props.options);

    _this.state = {
      visible: false,
      position: _constants.POSITION_BOTTOM,
      entries: _this.checkedSelectedItems(_entries),
      searchedEntries: [],
      isSearchActive: false
    };
    return _this;
  }

  _createClass(TreeSelect, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props2 = this.props,
          options = _this$props2.options,
          input = _this$props2.input;
      var visible = this.state.visible;

      if (visible !== prevState.visible) {
        this.determineDropdownPosition();
      }

      if (options !== prevProps.options || input.value !== prevProps.input.value) {
        var entries = this.convertOptionsToEntries(options);
        this.entries = this.checkedSelectedItems(entries);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          input = _this$props3.input,
          allowMultiSelect = _this$props3.allowMultiSelect,
          allowSelectNestedFolder = _this$props3.allowSelectNestedFolder,
          className = _this$props3.className,
          searchable = _this$props3.searchable,
          dataId = _this$props3.dataId;
      var _this$state = this.state,
          visible = _this$state.visible,
          position = _this$state.position;

      if (!input.value) {
        input.value = [];
      }

      return /*#__PURE__*/_jsx("div", {
        className: cx('xsui-tree-select', className),
        "data-id": dataId
      }, void 0, this.input, /*#__PURE__*/_jsx(_reactTransitionGroup.TransitionGroup, {}, void 0, visible && /*#__PURE__*/_jsx(_reactTransitionGroup.CSSTransition, {
        classNames: "slide-transition",
        timeout: 100
      }, void 0, /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.setDropdownRef,
        className: cx('xsui-tree-select__container', "xsui-tree-select__container--position-".concat(position))
      }, searchable && /*#__PURE__*/_jsx(_search["default"], {
        onSearch: this.filterEntries
      }), /*#__PURE__*/_jsx(_entries2["default"], {
        value: input.value,
        options: this.entries,
        allowMultiSelect: allowMultiSelect,
        allowSelectNestedFolder: allowSelectNestedFolder,
        handleChange: this.handleChange,
        handleSelectAll: this.handleSelectAll,
        handleUnselectAll: this.handleUnselectAll
      })))));
    }
  }, {
    key: "input",
    get: function get() {
      var _this$props4 = this.props,
          intl = _this$props4.intl,
          input = _this$props4.input,
          name = _this$props4.name,
          objective = _this$props4.objective,
          meta = _this$props4.meta,
          size = _this$props4.size,
          disabled = _this$props4.disabled,
          placeholder = _this$props4.placeholder;
      var commonProps = {
        meta: meta,
        size: size,
        offset: _constants.OFFSET_RIGHT,
        focused: this.state.visible,
        disabled: disabled,
        icon: 'dropdown-select',
        readOnly: true,
        placeholder: placeholder || intl.formatMessage(_messages["default"].placeholder),
        onClick: this.toggleVisible
      };
      var inputsMap = new Map([[_constants.OBJECTIVE_COUNT, /*#__PURE__*/_react["default"].createElement(_countSelect["default"], _extends({
        input: input
      }, commonProps))], [_constants.OBJECTIVE_PLAIN, /*#__PURE__*/_react["default"].createElement(_plainSelect["default"], _extends({
        input: input,
        name: name
      }, commonProps))], [_constants.OBJECTIVE_TAGS, /*#__PURE__*/_react["default"].createElement(_tagsSelect["default"], _extends({
        input: input,
        name: name
      }, commonProps))]]);
      return inputsMap.get(objective) || null;
    }
  }, {
    key: "entries",
    get: function get() {
      var _this$state2 = this.state,
          entries = _this$state2.entries,
          searchedEntries = _this$state2.searchedEntries,
          isSearchActive = _this$state2.isSearchActive;
      return isSearchActive ? searchedEntries : entries;
    },
    set: function set(entries) {
      var isSearchActive = this.state.isSearchActive;
      var entriesKey = isSearchActive ? 'searchedEntries' : 'entries';
      this.setState(_defineProperty({}, entriesKey, entries));
    }
  }]);

  return TreeSelect;
}(_react.PureComponent);

_defineProperty(TreeSelect, "defaultProps", {
  meta: {
    touched: false,
    error: null
  },
  options: [],
  allowMultiSelect: false,
  allowSelectNestedFolder: false,
  disabled: false,
  objective: _constants.OBJECTIVE_PLAIN,
  size: _constants.SIZE_SM,
  searchable: false
});

var _default = (0, _reactIntl.injectIntl)((0, _reactOnclickoutside["default"])(TreeSelect));

exports["default"] = _default;